import { MessageCircle } from "lucide-react";
import { waLink } from "./data";

export default function WhatsAppFloat() {
    return (
        <a
            href={waLink()}
            target="_blank"
            rel="noreferrer"
            aria-label="Chat with Baba Garments on WhatsApp"
            data-testid="whatsapp-float-button"
            className="group fixed bottom-5 right-5 z-[60] block h-14 w-14 sm:bottom-7 sm:right-7"
        >
            <span className="absolute inset-0 rounded-full bg-gold/50 animate-pulse-ring" aria-hidden="true" />
            <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-gold text-maroon-950 shadow-[0_14px_44px_-8px_rgba(212,175,55,0.75)] transition-transform duration-300 group-hover:scale-110">
                <MessageCircle size={24} />
            </span>
            <span className="pointer-events-none absolute right-full top-1/2 mr-3 -translate-y-1/2 translate-x-2 whitespace-nowrap rounded-full border border-gold/30 bg-maroon-950 px-4 py-2 text-xs font-medium text-cream opacity-0 transition-[opacity,transform] duration-300 group-hover:translate-x-0 group-hover:opacity-100">
                WhatsApp for wholesale rates
            </span>
        </a>
    );
}